<template>
  <!-- 树形结构的字典组件，用于separator布局放在左边，可自定义表单 -->
  <div class="tree-dictionary" style="">
    <div v-if="filter" class="tree-filter">
      <el-input v-model="filterText" :placeholder="placeholder"/>
    </div>
    <div class="add-new" v-if="!addFirstLevelAll && !disabled" title="新建数据" @click="toAddNewCategory({})">
      <yq-icon name="element-ui_plus"/>
      新建
    </div>
    <el-tree v-loading="loading" ref="tree" :data="treeList" :filter-node-method="filterNode" :props="{children: 'children', label: labelName}" @node-click="clickCategory" empty-text="数据为空" node-key="id" default-expand-all :expand-on-click-node="false" element-loading-text="正在加载数据" element-loading-spinner="el-icon-loading">
      <template #default="{node, data}">
        <!--            <span :class="currentDepart.id === data.id? 'tree-on': ''">{{data.departName}}</span>-->
        <span class="custom-tree-node">
          <slot name="default" :data="data">
            <span class="node-name">{{ data.departName || node.label }}</span>
          </slot>
          <span class="node-option">
            <slot name="treeOption" :data="data" :node="node">
              <el-dropdown v-if="editAble" @command="moreOption($event, data)" trigger="click">
                <template #default>
                  <yq-icon name="more-2"/>
                </template>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item command="addNewCategory">
                      <table-button :has-perm="rightAdd" :stop-pop="false">
                      <yq-icon name="element-ui_plus"/>{{ $t("message.toAddNew") }} <!-- 新建 -->
                      </table-button>
                    </el-dropdown-item>
                    <el-dropdown-item command="editCategory"  v-if="data.id">
                      <table-button :has-perm="rightEdit" :stop-pop="false">
                      <yq-icon name="element-ui_edit"/>{{$t("message.toEdit")}} <!--              编辑-->
                      </table-button>
                    </el-dropdown-item>
                    <el-dropdown-item command="deleteCategory"  v-if="data.id">
                      <table-button :has-perm="rightDelete" :stop-pop="false">
                      <yq-icon name="element-ui_delete"/>{{$t("message.toDelete")}}  <!--              删除-->
                      </table-button>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </slot>
          </span>
        </span>
      </template>
    </el-tree>

    <el-dialog :title="dialogLabel" v-model="showProductDialog" dialog-width="1" :close-on-click-modal="false">
      <dialog-table :auto-height="true">
        <slot name="edit" :categoryData="currentCategory">
          <el-form label-width="2.4rem" >
            <el-form-item label="上级分类">
              <el-tree-select :disabled="!!currentCategory.id" v-model="currentCategory.parentId" :data="treeList" default-expand-all check-strictly :render-after-expand="false" placeholder="请选择上级节点" :props="{children: 'children', label: 'dictName'}" node-key="id"/>
            </el-form-item>
            <el-form-item label="分类名称">
              <el-input v-model="currentCategory.dictName" placeholder="请输入分类名称"/>
            </el-form-item>
            <el-form-item label="排序序号">
              <el-input v-model="currentCategory.index" placeholder="请输入排序序号"/>
            </el-form-item>
            <el-form-item label="分类编码">
              <el-input v-model="currentCategory.userCode" placeholder="请输入分类编码"/>
            </el-form-item>
          </el-form>
        </slot>
      </dialog-table>
      <template #footer>
        <page-button @click="showProductDialog = false">取消</page-button>
        <page-button type="write" el-type="primary" @click="saveCategory">确定</page-button>
      </template>
    </el-dialog>
  </div>

</template>

<script>
import PageButton from "@/components/h5/button/PageButton";
import commonApi from "@/api/commonApi";
import dictionaryApi from "@/api/normal/sys/dictionaryApi";
import util from "@/util/util";
import {watch} from "vue";
import YqIcon from "@/components/YqIcon.vue";
import {ElMessageBox} from "element-plus";
import DialogTable from "@/components/h5/layout/DialogTable.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
export default {
  emits: ["clickCategory", "update:dictionaryList", "edit"],
  props: {
    codeName: {default: "dictCode"}, // 表示code的字段
    labelName: {default: "dictName"}, // 表示名称的字段
    // 字典列表，这个列表将会反写
    dictionaryList: {default: []},
    // 字典类型，不能为空
    dictionaryType: {default: ""},
    // 不可编辑
    disabled: {default: false},
    // 部分字典将以总部字典为准，需指定id
    merchantId: {default: ""},
    // 当前数据对应的code,可以通过code限制显示的数据范围，比如商户分类，商户只能查看自己归属的分类，不能查看其它数据
    code: {default: ""},
    dialogLabel: {default: "分类管理"}, // 显示在dialog的title
    queryFunction: {default: null}, // 查询树形结构的方法
    saveFunction: {default: null}, // 保存数据的方法
    deleteFunction: {default: null}, // 删除数据的方法，这三个方法适用于其它树形结构数据维护，如果是字典，不需要这三个方法，但字段名，统一按dictName和dictCode, userCode, children等几个
    filter: {default: false}, // 显示搜索过滤功能
    addFirstLevelAll: {default: true}, // 是否增加一个第一级的，全部标签，默认添加
    modelValue: {default: () => []},
    click2Dialog: {default: true}, // 点击时是否显示对话框，这个对话框用于编辑信息，如果设置为false,需要接收edit事件自己处理业务
    placeholder: {default: "输入关键字进行过滤显示"}, // 占位符
    // 权限，新建，编辑，删除
    rightAdd: {default: ""},
    rightEdit: {default: ""},
    rightDelete: {default: ""},
  },
  name: "TreeDictionary",
  components: {
    TableButton,
    YqIcon, PageButton, DialogTable,
  },
  data() {
    return {
      userInfo: {},
      treeList: [],
      editAble: true,
      currentCategory: {},
      showProductDialog: false,
      filterText: "",
      hasFormSlot: false, // 是否自定义了slot表单
      loading: false,
    };
  },
  created() {
    util.getUserInfo().then(user => {
      this.userInfo = user;
      this.loadData();
    })
    this.init();
    watch(() => this.code, () => this.init());
    watch(() => this.filterText, () => this.$refs.tree.filter(this.filterText));
    watch(() => this.modelValue, ()=> {
      if (this.modelValue && this.modelValue.length > 0) {
        this.treeList = this.modelValue;
      }
    })
    if (this.modelValue && this.modelValue.length > 0) {
      this.treeList = this.modelValue;
    }

  },
  methods: {
    // 加载树形数据
    loadData() {
      if (this.queryFunction !== null && this.saveFunction !== null && this.deleteFunction !== null) {
        // 如果设置了完整的数据回调，说明是其它类型的树结构数据
        this.initOtherTree();
        return;
      }
      this.init();
    },
    // 过滤显示
    filterNode(value, data) {
      if (!value) return true
      return data[this.labelName].indexOf(value) !== -1
    },
    // 初始化其它类型的数据
    initOtherTree() {
      this.loading = true;
      this.queryFunction(this.dictionaryType, this.userInfo.merchantId).then(list => {
        this.loading = false;
        let validList = this.showLimitCategory(list);
        // 将数据反写到父组件，用于显示
        this.$emit("update:dictionaryList", validList);
      })
    },
    init(force = false) { // 初始化，是否强制刷新数据

      if (this.merchantId && this.merchantId !== this.userInfo.merchantId) {
        // 指定了id，且id不同，不可编辑
        this.editAble = false;
      }
      if (this.disabled) {
        // 手动禁用了编辑，不可编辑
        this.editAble = false;
      }
      // 如果已经有字典了，不再加载
      if (this.dictionaryList && this.dictionaryList.length > 0 && !force) {
        this.treeList = this.dictionaryList;
      }else if (this.queryFunction) {
        this.loading = true;
        this.queryFunction(this.dictionaryType, this.merchantId).then(list => {
          this.loading = false;
          let validList = this.showLimitCategory(list);
          // 将数据反写到父组件，用于显示
          this.$emit("update:dictionaryList", validList);
        })
      } else if (this.dictionaryType){
        // 查询字典
        this.loading = true;
        commonApi.queryDictionaryTree(this.dictionaryType, this.merchantId).then(list => {
          this.loading = false;
          let validList = this.showLimitCategory(list);
          // 将数据反写到父组件，用于显示
          this.$emit("update:dictionaryList", validList);
        })
      }
    },
    // 数据受限显示，如果指定了code,只显示code下级，否则显示全部
    showLimitCategory(list) {
      if (this.code) {
        let d = this.getDataByCode(list, this.code);
        if (d.dictCode) {
          this.treeList = [d];
          return [d];
        } else {
          this.treeList = [];
          return [];
        }
      } else {
        if (this.addFirstLevelAll) {
          let allData = {children: list, id: ""};
          allData[this.codeName] = "";
          allData[this.labelName] = "全部";
          this.treeList = [allData]; // 添加一个全部，用作第一级
        } else {
          this.treeList = list;
        }
        return list;
      }
    },
    getDataByCode(list, code) {
      for (let i = 0; i < list.length; i++) {
        if (list[i].dictCode === code) {
          return list[i];
        }
        // 如果有下级
        if (list[i].children && list[i].children.length > 0) {
          let d = this.getDataByCode(list[i].children, code);
          if (d.dictCode) {
            return;
          }
        }
      }
      return {};
    },
    clickCategory(data) {
      this.$emit("clickCategory", data);
    },
    // 编辑，修改分类
    toAddNewCategory(data) {
      this.currentCategory = {...data};
      if (!this.currentCategory.type) {
        this.currentCategory.type = this.dictionaryType;
      }
      this.showProductDialog = true;
    },
    // 删除分类
    toDeleteCategory(id) {
      if (this.deleteFunction) {
        this.deleteFunction(id).then(() => this.init(true));
        return;
      }
      dictionaryApi.deleteById({id}).then(() => this.init(true));
    },
    saveCategory() {
      if (this.saveFunction) {
        this.saveFunction(this.currentCategory).then(() => {
          this.init(true);
          this.showProductDialog = false;
        });
        return;
      }
      dictionaryApi.saveTreeNode(this.currentCategory).then(() => {
        this.init(true);
        this.showProductDialog = false;
      });
    },
    // 更多操作
    moreOption(command, data) {
      switch ( command) {
        case "addNewCategory":
          if (this.click2Dialog) {
            this.toAddNewCategory({parentId: data.id});
          } else {
            this.$emit("addNew", data);
          }
          break;
        case "editCategory":
          if (this.click2Dialog) {
            console.log(data)
            this.toAddNewCategory(data);
          } else {
            this.$emit("edit", data);
          }
          break;
        case "deleteCategory":
          ElMessageBox.confirm("确定要删除吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            this.toDeleteCategory(data.id);
          });
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/el-tree";
.tree-dictionary{
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  .tree-filter{
    padding: 10px 10px 0;
  }
  .add-new{
    margin: 0 10px ;
    box-sizing: border-box;
    text-align: center;
    border: 1px solid var(--yq-border-color);
    font-size: 12px;
    line-height: 36px;
    height: 36px;
    color: var(--el-color-primary);
    border-radius: 4px;
    &:hover{
      background: var(--el-color-primary);
      color: #FFF;
    }
  }
  .el-tree{
    flex: 1;
    height: 100px;
    overflow: auto;
  }
}

</style>